import React, { useEffect, useState } from "react";

const LogTabs = ({ startingTabId,onActiveTabId,children  }) => {
    const [activeTabId, setActiveTabId] = useState(null);

    const handleClick=(tabId)=>{
        setActiveTabId(tabId);
        onActiveTabId(tabId);
    }
    useEffect(()=>{
        setActiveTabId(startingTabId);
    },[])
    return (
        <div className="tabs">
            {/* Tab Headers */}
            <div className="tab-headers flex space-x-4 border-b">
                {React.Children.map(children, (child, index) => {
                 const { id,label } = child.props; // Extract the label prop
                return (
                    <button
                        key={index}
                        onClick={() =>handleClick(id)}
                        className={`tab-button py-2 px-4 ${
                        activeTabId === id
                            ? "border-b-2 border-blue-500 text-blue-500"
                            : "text-gray-500"
                        }`}
                    >
                        {label}
                    </button>
                );
                })}
            </div>
            {/* Tab Content */}
            <div className="tab-content">
                {React.Children.map(children, (child, index) => {
                    const { id,label } = child.props; // Extract the label prop
                    return (
                        <div style={{ display: activeTabId === id ? 'block' : 'none' }}>
                            {child}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LogTabs;